import React, { useState, useEffect, Suspense } from "react";
import PeriodSlider from "../../components/GlobalComponents/PeriodSlider/PeriodSlider";
import { useSelector } from "react-redux";
import { useGetPriodById } from "../../components/Login/Hooks/Index";
import { useGetAllObjectiveDefinitionLevelByTenantId } from "./Hooks/index";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Box,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import AllObjectiveDetail from "./LComponents/AllObjectiveDetail/AllObjectiveDetail";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const Index: React.FC = function () {
  const [value, setValue] = React.useState(0);
  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const onSuccesss = (): void => {};

  const onFailed = (): void => {};

  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const {
    data: perData,
    isLoading: perLoading,
    isError: periodError,
    isFetched,
  }: any = useGetPriodById(tenantId, onSuccesss, onFailed);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [periodId, setPeriodId] = useState<string | null>(null);
  const { data: teamsOptions, isLoading: teamOPloading } =
    useGetAllObjectiveDefinitionLevelByTenantId(periodId,tenantId);
  const [teamId, setTeamId] = useState<string>("");
  const [teamId1, setTeamId1] = useState<string>("");

  useEffect(() => {
    const active: any = perData ? perData[activeIndex] : {};
    setPeriodId(active.id);
  }, [activeIndex]);

  useEffect(() => {
    let length = perData?.map((e: any) => e.isCurrent).indexOf(true);
    if (length !== 4) {
      setActiveIndex(4);
    }
  }, []);

  useEffect(() => {
    if (perData) {
      let length: number = perData.length;
      if (length === 4) {
        setActiveIndex(0);
      }
    }
  }, [perData]);


  useEffect(() => {
    if (teamsOptions) {
      if (teamsOptions !== null && teamsOptions !== undefined) {
        const y = teamsOptions.filter((x:any) => x.key === 'شرکت');
        const yy = y[0];
        let {value} = yy || {};
        setTeamId1(value);
      }
    }
  }, [teamsOptions]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <PeriodSlider
        setActiveIndex={setActiveIndex}
        setPriodId={setPeriodId}
        activeIndex={perData?.findIndex((item: any) => item.isCurrent)}
        tenantId={tenantId}
        slideData={perData}
        dataLoading={perLoading}
      />
      <Grid container>
        <Grid item xs={12} md={12}>
          <Box sx={{ width: "100%" }}>
            <Grid item xs={12} md={4}>
              <Box justifyContent="center" width={"100%"} height={"100%"}>
                <Typography
                  px={1}
                  variant="button"
                  fontWeight={900}
                  color={"black"}
                  fontSize={'13px'}
                >
                  {" "}
هدف مورد نظر را انتخاب کنید
                </Typography>
              </Box>
              <Box
                padding={"8px"}
                justifyContent="center"
                width={"100%"}
                height={"100%"}
              >
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">هدف</InputLabel>
                  <Select
           
                    labelId="demo-simple-select-label"
                    id="demo-simple-selectd"
                    // value={teamId1 || ''}
                    // defaultValue="fb7cc4ea-7162-4916-9aa8-834b14308e10"
                    label="هدف"
                    onChange={(e: any, other: any) => {
                      let { props } = other;
                      let { children: keyName, content } = props;
                      let { value } = props;
                      setTeamId(value);
                      let { target } = e;
                      // let{value}=target;
                    }}
                  >
                    {teamsOptions &&
                      teamsOptions.map((item: any) => {
                        let { key, value, isCompany } = item;
                        return (
                          <MenuItem key={key} value={value} content={isCompany}>
                            {key}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
                
              </Box>
            </Grid>

            <CustomTabPanel value={value} index={0}>
              <Suspense
                fallback={
                  <Box width={"100%"} pt={5} textAlign={"center"} py={5}>
                    <CircularProgress />
                  </Box>
                }
              >
                <AllObjectiveDetail
                  periodId={periodId}
                  periodsData={perData}
                  teamId={teamId}
                />
              </Suspense>
            </CustomTabPanel>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Index;
